module.exports = __webpack_public_path__ + "img/tracing_point.a6a341e9.svg";